// src/pages/RestaurantSettingsPage.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Chip,
  Stack,
  Divider,
  MenuItem,
  Paper,
  Tab,
  Tabs,
  Avatar,
  IconButton,
  Tooltip,
  Alert,
  Snackbar,
  Switch,
  FormControlLabel,
  Grid,
  InputAdornment,
  Collapse,
  Fade,
  Zoom,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Fab,
  useMediaQuery,
  useTheme,
  Drawer,
  AppBar,
  Toolbar,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useNotify } from "react-admin";

// Icons
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteIcon from "@mui/icons-material/Delete";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import GavelIcon from "@mui/icons-material/Gavel";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import MenuIcon from "@mui/icons-material/Menu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const API = "https://api.haymestasarim.com/api";

/* =================== RENK PALETİ =================== */
const COLORS = {
  primary: "#1976d2",
  accent: "#f57c00",
  success: "#2e7d32",
  warning: "#ed6c02",
  error: "#d32f2f",
  info: "#0288d1",
  purple: "#9c27b0",
  teal: "#009688",
};

/* =================== I18N =================== */
const I18N = {
  tr: {
    title: "Kurum Ayarları",
    subtitle: "Çalışma saatleri, personel ve kaynakları yönetin",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    saved: "Ayarlar kaydedildi",
    error: "Kaydetme başarısız",
    cancel: "İptal",
    delete: "Sil",
    add: "Ekle",
    close: "Kapat",
    confirm: "Onayla",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    menu: "Menü",
    
    // Kurum Tipleri
    restaurant: "Restoran",
    healthcare: "Sağlık",
    legal: "Hukuk",
    finance: "Finans",
    other: "Diğer",
    
    // Sekmeler
    tabGeneral: "Genel Ayarlar",
    tabCalendar: "Takvim & Çalışma Saatleri",
    tabResources: "Personel & Kaynaklar",
    tabTables: "Masa Planı",
    
    // Genel Ayarlar
    generalSettings: "Genel Ayarlar",
    bookingSystem: "Randevu Sistemi",
    enableBooking: "Randevu Sistemini Aktif Et",
    slotDuration: "Randevu Süresi",
    gapMinutes: "Randevu Arası Boşluk",
    maxDays: "Maksimum İleri Gün",
    requireApproval: "Onay Gerekli",
    
    // Takvim Ayarları
    calendarSettings: "Takvim Ayarları",
    weeklyHours: "Haftalık Çalışma Saatleri",
    specialDays: "Özel Günler",
    closedDays: "Kapalı Günler",
    addSpecialDay: "Özel Gün Ekle",
    addClosedDay: "Kapalı Gün Ekle",
    date: "Tarih",
    startTime: "Başlangıç",
    endTime: "Bitiş",
    open: "Açık",
    closed: "Kapalı",
    monday: "Pazartesi",
    tuesday: "Salı",
    wednesday: "Çarşamba",
    thursday: "Perşembe",
    friday: "Cuma",
    saturday: "Cumartesi",
    sunday: "Pazar",
    lunchBreak: "Öğle Arası",
    
    // Personel/Kaynaklar
    staff: "Personel",
    addStaff: "Personel Ekle",
    name: "Ad Soyad",
    specialization: "Uzmanlık",
    phone: "Telefon",
    email: "E-posta",
    active: "Aktif",
    passive: "Pasif",
    
    // Restoran Masaları
    tables: "Masalar",
    addSalon: "Salon Ekle",
    addTable: "Masa Ekle",
    salonName: "Salon Adı",
    tableName: "Masa Adı",
    capacity: "Kapasite",
    
    // Uyarılar
    minutes: "dk",
    hours: "saat",
    days: "gün",
  },
  en: {
    title: "Institution Settings",
    subtitle: "Manage working hours, staff and resources",
    save: "Save",
    saving: "Saving...",
    saved: "Settings saved",
    error: "Save failed",
    cancel: "Cancel",
    delete: "Delete",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    refresh: "Refresh",
    loading: "Loading...",
    menu: "Menu",
    
    restaurant: "Restaurant",
    healthcare: "Healthcare",
    legal: "Legal",
    finance: "Finance",
    other: "Other",
    
    tabGeneral: "General Settings",
    tabCalendar: "Calendar & Hours",
    tabResources: "Staff & Resources",
    tabTables: "Table Layout",
    
    generalSettings: "General Settings",
    bookingSystem: "Booking System",
    enableBooking: "Enable Booking System",
    slotDuration: "Slot Duration",
    gapMinutes: "Gap Between Slots",
    maxDays: "Max Advance Days",
    requireApproval: "Require Approval",
    
    calendarSettings: "Calendar Settings",
    weeklyHours: "Weekly Working Hours",
    specialDays: "Special Days",
    closedDays: "Closed Days",
    addSpecialDay: "Add Special Day",
    addClosedDay: "Add Closed Day",
    date: "Date",
    startTime: "Start",
    endTime: "End",
    open: "Open",
    closed: "Closed",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    lunchBreak: "Lunch Break",
    
    staff: "Staff",
    addStaff: "Add Staff",
    name: "Full Name",
    specialization: "Specialization",
    phone: "Phone",
    email: "Email",
    active: "Active",
    passive: "Passive",
    
    tables: "Tables",
    addSalon: "Add Hall",
    addTable: "Add Table",
    salonName: "Hall Name",
    tableName: "Table Name",
    capacity: "Capacity",
    
    minutes: "min",
    hours: "hours",
    days: "days",
  },
  de: {
    title: "Einrichtungseinstellungen",
    subtitle: "Verwalten Sie Arbeitszeiten, Personal und Ressourcen",
    save: "Speichern",
    saving: "Speichern...",
    saved: "Einstellungen gespeichert",
    error: "Speichern fehlgeschlagen",
    cancel: "Abbrechen",
    delete: "Löschen",
    add: "Hinzufügen",
    close: "Schließen",
    confirm: "Bestätigen",
    refresh: "Aktualisieren",
    loading: "Laden...",
    menu: "Menü",
    
    restaurant: "Restaurant",
    healthcare: "Gesundheit",
    legal: "Recht",
    finance: "Finanzen",
    other: "Andere",
    
    tabGeneral: "Allgemein",
    tabCalendar: "Kalender & Zeiten",
    tabResources: "Personal & Ressourcen",
    tabTables: "Tischplan",
    
    generalSettings: "Allgemeine Einstellungen",
    bookingSystem: "Buchungssystem",
    enableBooking: "Buchungssystem aktivieren",
    slotDuration: "Termindauer",
    gapMinutes: "Pause zwischen Terminen",
    maxDays: "Max. Voraus Tage",
    requireApproval: "Genehmigung erforderlich",
    
    calendarSettings: "Kalendereinstellungen",
    weeklyHours: "Wöchentliche Arbeitszeiten",
    specialDays: "Besondere Tage",
    closedDays: "Geschlossene Tage",
    addSpecialDay: "Besonderen Tag hinzufügen",
    addClosedDay: "Geschlossenen Tag hinzufügen",
    date: "Datum",
    startTime: "Start",
    endTime: "Ende",
    open: "Geöffnet",
    closed: "Geschlossen",
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    lunchBreak: "Mittagspause",
    
    staff: "Personal",
    addStaff: "Personal hinzufügen",
    name: "Name",
    specialization: "Spezialisierung",
    phone: "Telefon",
    email: "E-Mail",
    active: "Aktiv",
    passive: "Passiv",
    
    tables: "Tische",
    addSalon: "Saal hinzufügen",
    addTable: "Tisch hinzufügen",
    salonName: "Saalname",
    tableName: "Tisch name",
    capacity: "Kapazität",
    
    minutes: "Min.",
    hours: "Std.",
    days: "Tage",
  },
};

function getLang() {
  const l = localStorage.getItem("app_lang") || "tr";
  return ["tr", "en", "de"].includes(l) ? l : "tr";
}

function authHeaders() {
  return {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
}

const BUSINESS_TYPES = [
  { id: "restaurant", icon: <RestaurantIcon />, label: "restaurant", color: COLORS.accent },
  { id: "healthcare", icon: <MedicalServicesIcon />, label: "healthcare", color: COLORS.success },
  { id: "legal", icon: <GavelIcon />, label: "legal", color: COLORS.primary },
  { id: "finance", icon: <AccountBalanceIcon />, label: "finance", color: COLORS.purple },
  { id: "other", icon: <BusinessIcon />, label: "other", color: COLORS.teal },
];

const DAYS = [
  { key: "monday", labelKey: "monday" },
  { key: "tuesday", labelKey: "tuesday" },
  { key: "wednesday", labelKey: "wednesday" },
  { key: "thursday", labelKey: "thursday" },
  { key: "friday", labelKey: "friday" },
  { key: "saturday", labelKey: "saturday" },
  { key: "sunday", labelKey: "sunday" },
];

/* ================= ANA BİLEŞEN ================= */
export default function RestaurantSettingsPage() {
  const notify = useNotify();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  const T = I18N[getLang()];
  
  const [businessType, setBusinessType] = useState("restaurant");
  const [activeTab, setActiveTab] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Genel Ayarlar
  const [settings, setSettings] = useState({
    randevu_aktif: false,
    slot_suresi: 30,
    gap_minutes: 0,
    max_ileri_gun: 365,
    onay_zorunlu: true,
  });
  
  // Çalışma Saatleri
  const [workingHours, setWorkingHours] = useState(() => {
    const hours = {};
    DAYS.forEach(day => {
      hours[day.key] = {
        enabled: day.key !== "sunday",
        start: "09:00",
        end: "18:00",
        lunchEnabled: day.key !== "saturday" && day.key !== "sunday",
        lunchStart: "12:00",
        lunchEnd: "13:00",
      };
    });
    return hours;
  });
  
  // Özel Günler
  const [specialDays, setSpecialDays] = useState([]);
  const [closedDays, setClosedDays] = useState([]);
  
  // Personel/Kaynaklar
  const [staff, setStaff] = useState([]);
  
  // Restoran Masaları
  const [salons, setSalons] = useState([]);
  
  // UI State
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null, type: "", salonId: null });
  
  // Verileri yükle
  useEffect(() => {
    fetchSettings();
    fetchResources();
  }, [businessType]);
  
  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API}/randevu/settings`, { headers: authHeaders() });
      const json = await res.json();
      const data = json?.data || {};
      
      setSettings({
        randevu_aktif: data.randevu_aktif || false,
        slot_suresi: data.slot_suresi || 30,
        gap_minutes: data.gap_minutes || 0,
        max_ileri_gun: data.max_ileri_gun || 365,
        onay_zorunlu: data.onay_zorunlu || true,
      });
      
      if (data.hours) {
        setWorkingHours(prev => ({ ...prev, ...data.hours }));
      }
      
      setSpecialDays(data.special_days || []);
      setClosedDays(data.closed_days || []);
      
    } catch (error) {
      showNotification(T.error, "error");
    } finally {
      setLoading(false);
    }
  };
  
  const fetchResources = async () => {
    try {
      if (businessType === "restaurant") {
        const res = await fetch(`${API}/randevu/restaurant/settings`, { headers: authHeaders() });
        const json = await res.json();
        setSalons(json?.data || []);
      } else {
        const res = await fetch(`${API}/randevu/resources?tip=${businessType}`, { headers: authHeaders() });
        const json = await res.json();
        setStaff(json?.data || []);
      }
    } catch (error) {
      console.error("Resource fetch error:", error);
    }
  };
  
  const showNotification = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
    notify(message, { type: severity });
  };
  
  const saveSettings = async () => {
    try {
      setSaving(true);
      
      await fetch(`${API}/randevu/settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({
          ...settings,
          hours: workingHours,
          special_days: specialDays,
          closed_days: closedDays,
        }),
      });
      
      if (businessType === "restaurant") {
        await fetch(`${API}/randevu/restaurant/settings`, {
          method: "POST",
          headers: authHeaders(),
          body: JSON.stringify({ salons }),
        });
      } else {
        for (const s of staff) {
          if (s.id && s.id.toString().startsWith("temp")) {
            await fetch(`${API}/randevu/resources`, {
              method: "POST",
              headers: authHeaders(),
              body: JSON.stringify(s),
            });
          } else if (s.id) {
            await fetch(`${API}/randevu/resources/${s.id}`, {
              method: "PUT",
              headers: authHeaders(),
              body: JSON.stringify(s),
            });
          }
        }
      }
      
      showNotification(T.saved);
      
    } catch (error) {
      showNotification(T.error, "error");
    } finally {
      setSaving(false);
    }
  };
  
  // Staff işlemleri
  const addStaff = () => {
    const newStaff = {
      id: "temp_" + Date.now(),
      ad: "",
      tip: businessType,
      aktif: true,
      telefon: "",
      email: "",
      uzmanlik: "",
    };
    setStaff([...staff, newStaff]);
  };
  
  const updateStaff = (id, field, value) => {
    setStaff(staff.map(s => s.id === id ? { ...s, [field]: value } : s));
  };
  
  const deleteStaff = (id) => {
    setStaff(staff.filter(s => s.id !== id));
    setDeleteDialog({ open: false, id: null, type: "" });
  };
  
  // Salon işlemleri
  const addSalon = () => {
    setSalons([
      ...salons,
      {
        id: "temp_" + Date.now(),
        name: `Salon ${salons.length + 1}`,
        tables: [],
      },
    ]);
  };
  
  const addTable = (salonId) => {
    setSalons(salons.map(salon => {
      if (salon.id === salonId) {
        return {
          ...salon,
          tables: [
            ...salon.tables,
            {
              id: "temp_" + Date.now(),
              name: `M${salon.tables.length + 1}`,
              capacity: 4,
              active: true,
              x: 50 + (salon.tables.length * 60),
              y: 50 + (salon.tables.length * 60),
            },
          ],
        };
      }
      return salon;
    }));
  };
  
  const updateTable = (salonId, tableId, patch) => {
    setSalons(salons.map(salon => {
      if (salon.id === salonId) {
        return {
          ...salon,
          tables: salon.tables.map(table =>
            table.id === tableId ? { ...table, ...patch } : table
          ),
        };
      }
      return salon;
    }));
  };
  
  const deleteTable = (salonId, tableId) => {
    setSalons(salons.map(salon => {
      if (salon.id === salonId) {
        return {
          ...salon,
          tables: salon.tables.filter(t => t.id !== tableId),
        };
      }
      return salon;
    }));
    setDeleteDialog({ open: false, id: null, type: "" });
  };
  
  const deleteSalon = (salonId) => {
    setSalons(salons.filter(s => s.id !== salonId));
    setDeleteDialog({ open: false, id: null, type: "" });
  };
  
  // Special days
  const addSpecialDay = () => {
    setSpecialDays([
      ...specialDays,
      {
        date: new Date().toISOString().slice(0, 10),
        enabled: true,
        start: "09:00",
        end: "18:00",
        description: "",
      },
    ]);
  };
  
  const addClosedDay = () => {
    setClosedDays([...closedDays, new Date().toISOString().slice(0, 10)]);
  };
  
  const getActiveColor = () => {
    const biz = BUSINESS_TYPES.find(b => b.id === businessType);
    return biz?.color || COLORS.primary;
  };
  
  // Menü öğeleri
  const menuItems = [
    { index: 0, icon: <SettingsIcon />, label: T.tabGeneral },
    { index: 1, icon: <CalendarTodayIcon />, label: T.tabCalendar },
    { index: 2, icon: <GroupIcon />, label: T.tabResources },
    ...(businessType === "restaurant" ? [{ index: 3, icon: <TableRestaurantIcon />, label: T.tabTables }] : []),
  ];
  
  // Mobil Menü (Drawer)
  const MobileMenu = () => (
    <Drawer
      anchor="left"
      open={mobileMenuOpen}
      onClose={() => setMobileMenuOpen(false)}
      PaperProps={{
        sx: { width: "100%", maxWidth: "100%" }
      }}
    >
      <Box sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h6">{T.menu}</Typography>
          <IconButton onClick={() => setMobileMenuOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <List>
          {menuItems.map((item) => (
            <ListItem
              key={item.index}
              button
              selected={activeTab === item.index}
              onClick={() => {
                setActiveTab(item.index);
                setMobileMenuOpen(false);
              }}
              sx={{
                borderRadius: 2,
                mb: 1,
                bgcolor: activeTab === item.index ? `${getActiveColor()}15` : "transparent",
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: activeTab === item.index ? getActiveColor() : "grey.300" }}>
                  {item.icon}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
  
  return (
    <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      
      {/* Üst Bar */}
      <AppBar position="sticky" sx={{ bgcolor: "white", color: "text.primary", boxShadow: 1 }}>
        <Toolbar>
          {isMobile && (
            <IconButton edge="start" onClick={() => setMobileMenuOpen(true)} sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          )}
          <SettingsIcon sx={{ mr: 1, color: getActiveColor() }} />
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
            {T.title}
          </Typography>
          <Button
            variant="contained"
            startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
            onClick={saveSettings}
            disabled={saving}
            sx={{ bgcolor: getActiveColor() }}
          >
            {saving ? T.saving : T.save}
          </Button>
        </Toolbar>
      </AppBar>
      
      {/* Kurum Tipi Seçici */}
      <Box sx={{ p: 2, bgcolor: "white", borderBottom: 1, borderColor: "divider" }}>
        <Stack direction="row" spacing={1} sx={{ overflowX: "auto", pb: 1 }}>
          {BUSINESS_TYPES.map((type) => (
            <Chip
              key={type.id}
              icon={type.icon}
              label={T[type.label]}
              onClick={() => setBusinessType(type.id)}
              sx={{
                bgcolor: businessType === type.id ? type.color : "transparent",
                color: businessType === type.id ? "white" : type.color,
                border: `1px solid ${type.color}`,
                "&:hover": {
                  bgcolor: businessType === type.id ? type.color : `${type.color}20`,
                },
                py: 2.5,
              }}
            />
          ))}
        </Stack>
      </Box>
      
      <MobileMenu />
      
      {/* Ana İçerik */}
      <Grid container>
        {/* Sol Menü - Masaüstü */}
        {!isMobile && (
          <Grid item md={2.5} lg={2}>
            <Box sx={{ p: 2, position: "sticky", top: 80 }}>
              <Paper sx={{ borderRadius: 2 }}>
                <List>
                  {menuItems.map((item) => (
                    <ListItem
                      key={item.index}
                      button
                      selected={activeTab === item.index}
                      onClick={() => setActiveTab(item.index)}
                      sx={{
                        borderLeft: activeTab === item.index ? `4px solid ${getActiveColor()}` : "4px solid transparent",
                        bgcolor: activeTab === item.index ? `${getActiveColor()}10` : "transparent",
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ bgcolor: activeTab === item.index ? getActiveColor() : "grey.300", width: 32, height: 32 }}>
                          {item.icon}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Box>
          </Grid>
        )}
        
        {/* Sağ İçerik */}
        <Grid item xs={12} md={isMobile ? 12 : 9.5} lg={isMobile ? 12 : 10}>
          <Box sx={{ p: 2 }}>
            <Fade in={true}>
              <Card sx={{ borderRadius: 2 }}>
                <CardContent>
                  
                  {/* GENEL AYARLAR */}
                  {activeTab === 0 && (
                    <Stack spacing={3}>
                      <Typography variant="h6" fontWeight={700} sx={{ color: getActiveColor() }}>
                        {T.generalSettings}
                      </Typography>
                      
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Stack spacing={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={settings.randevu_aktif}
                                onChange={(e) => setSettings({ ...settings, randevu_aktif: e.target.checked })}
                              />
                            }
                            label={T.enableBooking}
                          />
                          
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                type="number"
                                label={T.slotDuration}
                                value={settings.slot_suresi}
                                onChange={(e) => setSettings({ ...settings, slot_suresi: parseInt(e.target.value) || 30 })}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{T.minutes}</InputAdornment>,
                                }}
                              />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                type="number"
                                label={T.gapMinutes}
                                value={settings.gap_minutes}
                                onChange={(e) => setSettings({ ...settings, gap_minutes: parseInt(e.target.value) || 0 })}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{T.minutes}</InputAdornment>,
                                }}
                              />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                type="number"
                                label={T.maxDays}
                                value={settings.max_ileri_gun}
                                onChange={(e) => setSettings({ ...settings, max_ileri_gun: parseInt(e.target.value) || 365 })}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{T.days}</InputAdornment>,
                                }}
                              />
                            </Grid>
                          </Grid>
                          
                          <FormControlLabel
                            control={
                              <Switch
                                checked={settings.onay_zorunlu}
                                onChange={(e) => setSettings({ ...settings, onay_zorunlu: e.target.checked })}
                              />
                            }
                            label={T.requireApproval}
                          />
                        </Stack>
                      </Paper>
                    </Stack>
                  )}
                  
                  {/* TAKVİM & ÇALIŞMA SAATLERİ */}
                  {activeTab === 1 && (
                    <Stack spacing={3}>
                      <Typography variant="h6" fontWeight={700} sx={{ color: getActiveColor() }}>
                        {T.calendarSettings}
                      </Typography>
                      
                      {/* Haftalık Çalışma Saatleri */}
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Typography fontWeight={600} gutterBottom>{T.weeklyHours}</Typography>
                        
                        {DAYS.map((day) => {
                          const h = workingHours[day.key] || { enabled: false, start: "09:00", end: "18:00", lunchEnabled: false };
                          
                          return (
                            <Paper key={day.key} variant="outlined" sx={{ p: 2, mb: 2 }}>
                              <Stack spacing={2}>
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
                                  <Typography sx={{ minWidth: 100 }} fontWeight={500}>
                                    {T[day.labelKey]}
                                  </Typography>
                                  
                                  <Chip
                                    label={h.enabled ? T.open : T.closed}
                                    color={h.enabled ? "success" : "default"}
                                    onClick={() => setWorkingHours({
                                      ...workingHours,
                                      [day.key]: { ...h, enabled: !h.enabled },
                                    })}
                                  />
                                  
                                  {h.enabled && (
                                    <>
                                      <TextField
                                        type="time"
                                        size="small"
                                        label={T.startTime}
                                        value={h.start}
                                        onChange={(e) => setWorkingHours({
                                          ...workingHours,
                                          [day.key]: { ...h, start: e.target.value },
                                        })}
                                        InputLabelProps={{ shrink: true }}
                                      />
                                      <TextField
                                        type="time"
                                        size="small"
                                        label={T.endTime}
                                        value={h.end}
                                        onChange={(e) => setWorkingHours({
                                          ...workingHours,
                                          [day.key]: { ...h, end: e.target.value },
                                        })}
                                        InputLabelProps={{ shrink: true }}
                                      />
                                    </>
                                  )}
                                </Stack>
                                
                                {h.enabled && (
                                  <>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          size="small"
                                          checked={h.lunchEnabled || false}
                                          onChange={(e) => setWorkingHours({
                                            ...workingHours,
                                            [day.key]: { ...h, lunchEnabled: e.target.checked },
                                          })}
                                        />
                                      }
                                      label={T.lunchBreak}
                                    />
                                    
                                    {h.lunchEnabled && (
                                      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                          type="time"
                                          size="small"
                                          label={T.startTime}
                                          value={h.lunchStart || "12:00"}
                                          onChange={(e) => setWorkingHours({
                                            ...workingHours,
                                            [day.key]: { ...h, lunchStart: e.target.value },
                                          })}
                                          InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                          type="time"
                                          size="small"
                                          label={T.endTime}
                                          value={h.lunchEnd || "13:00"}
                                          onChange={(e) => setWorkingHours({
                                            ...workingHours,
                                            [day.key]: { ...h, lunchEnd: e.target.value },
                                          })}
                                          InputLabelProps={{ shrink: true }}
                                        />
                                      </Stack>
                                    )}
                                  </>
                                )}
                              </Stack>
                            </Paper>
                          );
                        })}
                      </Paper>
                      
                      {/* Özel Günler */}
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography fontWeight={600}>{T.specialDays}</Typography>
                          <Button size="small" startIcon={<AddIcon />} onClick={addSpecialDay}>
                            {T.addSpecialDay}
                          </Button>
                        </Stack>
                        
                        {specialDays.map((day, index) => (
                          <Paper key={index} variant="outlined" sx={{ p: 2, mb: 2 }}>
                            <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
                              <TextField
                                type="date"
                                size="small"
                                value={day.date}
                                onChange={(e) => {
                                  const newDays = [...specialDays];
                                  newDays[index].date = e.target.value;
                                  setSpecialDays(newDays);
                                }}
                                InputLabelProps={{ shrink: true }}
                                sx={{ minWidth: 150 }}
                              />
                              
                              <Chip
                                label={day.enabled ? T.open : T.closed}
                                color={day.enabled ? "success" : "default"}
                                onClick={() => {
                                  const newDays = [...specialDays];
                                  newDays[index].enabled = !newDays[index].enabled;
                                  setSpecialDays(newDays);
                                }}
                              />
                              
                              {day.enabled && (
                                <>
                                  <TextField
                                    type="time"
                                    size="small"
                                    label={T.startTime}
                                    value={day.start || "09:00"}
                                    onChange={(e) => {
                                      const newDays = [...specialDays];
                                      newDays[index].start = e.target.value;
                                      setSpecialDays(newDays);
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                  <TextField
                                    type="time"
                                    size="small"
                                    label={T.endTime}
                                    value={day.end || "18:00"}
                                    onChange={(e) => {
                                      const newDays = [...specialDays];
                                      newDays[index].end = e.target.value;
                                      setSpecialDays(newDays);
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </>
                              )}
                              
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => setSpecialDays(specialDays.filter((_, i) => i !== index))}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Stack>
                          </Paper>
                        ))}
                        {specialDays.length === 0 && (
                          <Alert severity="info">Henüz özel gün eklenmemiş.</Alert>
                        )}
                      </Paper>
                      
                      {/* Kapalı Günler */}
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography fontWeight={600}>{T.closedDays}</Typography>
                          <Button size="small" startIcon={<AddIcon />} onClick={addClosedDay}>
                            {T.addClosedDay}
                          </Button>
                        </Stack>
                        
                        <Grid container spacing={1}>
                          {closedDays.map((day, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                              <Paper variant="outlined" sx={{ p: 1, display: "flex", alignItems: "center", gap: 1 }}>
                                <TextField
                                  type="date"
                                  size="small"
                                  value={day}
                                  onChange={(e) => {
                                    const newDays = [...closedDays];
                                    newDays[index] = e.target.value;
                                    setClosedDays(newDays);
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                />
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => setClosedDays(closedDays.filter((_, i) => i !== index))}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Paper>
                            </Grid>
                          ))}
                          {closedDays.length === 0 && (
                            <Grid item xs={12}>
                              <Alert severity="info">Henüz kapalı gün eklenmemiş.</Alert>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    </Stack>
                  )}
                  
                  {/* PERSONEL & KAYNAKLAR */}
                  {activeTab === 2 && (
                    <Stack spacing={3}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight={700} sx={{ color: getActiveColor() }}>
                          {T.staff}
                        </Typography>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={addStaff}
                          sx={{ bgcolor: getActiveColor() }}
                        >
                          {T.addStaff}
                        </Button>
                      </Stack>
                      
                      {staff.length === 0 ? (
                        <Alert severity="info">Henüz personel eklenmemiş.</Alert>
                      ) : (
                        <Grid container spacing={2}>
                          {staff.map((person) => (
                            <Grid item xs={12} md={6} key={person.id}>
                              <Card variant="outlined" sx={{ borderRadius: 2 }}>
                                <CardContent>
                                  <Stack spacing={2}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                      <TextField
                                        size="small"
                                        placeholder={T.name}
                                        value={person.ad}
                                        onChange={(e) => updateStaff(person.id, "ad", e.target.value)}
                                        fullWidth
                                      />
                                      <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => setDeleteDialog({ open: true, id: person.id, type: "staff" })}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                    
                                    <Grid container spacing={1}>
                                      <Grid item xs={12}>
                                        <TextField
                                          size="small"
                                          label={T.specialization}
                                          value={person.uzmanlik || ""}
                                          onChange={(e) => updateStaff(person.id, "uzmanlik", e.target.value)}
                                          fullWidth
                                        />
                                      </Grid>
                                    </Grid>
                                    
                                    <Grid container spacing={1}>
                                      <Grid item xs={6}>
                                        <TextField
                                          size="small"
                                          label={T.phone}
                                          value={person.telefon || ""}
                                          onChange={(e) => updateStaff(person.id, "telefon", e.target.value)}
                                          fullWidth
                                        />
                                      </Grid>
                                      <Grid item xs={6}>
                                        <TextField
                                          size="small"
                                          label={T.email}
                                          value={person.email || ""}
                                          onChange={(e) => updateStaff(person.id, "email", e.target.value)}
                                          fullWidth
                                        />
                                      </Grid>
                                    </Grid>
                                    
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          size="small"
                                          checked={person.aktif}
                                          onChange={(e) => updateStaff(person.id, "aktif", e.target.checked)}
                                        />
                                      }
                                      label={person.aktif ? T.active : T.passive}
                                    />
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Stack>
                  )}
                  
                  {/* RESTORAN MASA PLANI */}
                  {activeTab === 3 && businessType === "restaurant" && (
                    <Stack spacing={3}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight={700} sx={{ color: getActiveColor() }}>
                          {T.tables}
                        </Typography>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={addSalon}
                          sx={{ bgcolor: getActiveColor() }}
                        >
                          {T.addSalon}
                        </Button>
                      </Stack>
                      
                      {salons.length === 0 ? (
                        <Alert severity="info">Henüz salon eklenmemiş.</Alert>
                      ) : (
                        salons.map((salon) => (
                          <Card key={salon.id} variant="outlined" sx={{ borderRadius: 2 }}>
                            <CardContent>
                              <Stack spacing={2}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                  <TextField
                                    label={T.salonName}
                                    value={salon.name}
                                    onChange={(e) => {
                                      setSalons(salons.map(s =>
                                        s.id === salon.id ? { ...s, name: e.target.value } : s
                                      ));
                                    }}
                                    size="small"
                                    sx={{ minWidth: 200 }}
                                  />
                                  <Stack direction="row" spacing={1}>
                                    <IconButton
                                      size="small"
                                      onClick={() => addTable(salon.id)}
                                      sx={{ color: getActiveColor() }}
                                    >
                                      <AddIcon />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => setDeleteDialog({ open: true, id: salon.id, type: "salon" })}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Stack>
                                </Stack>
                                
                                <Divider />
                                
                                {/* Masa Grid */}
                                <Paper
                                  variant="outlined"
                                  sx={{
                                    position: "relative",
                                    height: 400,
                                    bgcolor: "#f9f9f9",
                                    overflow: "auto",
                                    borderRadius: 2,
                                  }}
                                >
                                  {salon.tables.map((table) => (
                                    <Box
                                      key={table.id}
                                      onMouseDown={(e) => {
                                        const startX = e.clientX;
                                        const startY = e.clientY;
                                        const startLeft = table.x || 50;
                                        const startTop = table.y || 50;
                                        
                                        const onMouseMove = (moveEvent) => {
                                          const dx = moveEvent.clientX - startX;
                                          const dy = moveEvent.clientY - startY;
                                          updateTable(salon.id, table.id, {
                                            x: startLeft + dx,
                                            y: startTop + dy,
                                          });
                                        };
                                        
                                        const onMouseUp = () => {
                                          document.removeEventListener('mousemove', onMouseMove);
                                          document.removeEventListener('mouseup', onMouseUp);
                                        };
                                        
                                        document.addEventListener('mousemove', onMouseMove);
                                        document.addEventListener('mouseup', onMouseUp);
                                      }}
                                      sx={{
                                        position: "absolute",
                                        left: table.x || 50,
                                        top: table.y || 50,
                                        width: 60,
                                        height: 60,
                                        borderRadius: 2,
                                        bgcolor: table.active ? getActiveColor() : "#aaa",
                                        color: "white",
                                        cursor: "grab",
                                        p: 0.5,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: 2,
                                        "&:hover": { boxShadow: 4 },
                                      }}
                                    >
                                      <Typography fontWeight={900} fontSize="0.8rem">
                                        {table.name}
                                      </Typography>
                                      <Typography variant="caption">
                                        {table.capacity}
                                      </Typography>
                                    </Box>
                                  ))}
                                </Paper>
                              </Stack>
                            </CardContent>
                          </Card>
                        ))
                      )}
                    </Stack>
                  )}
                </CardContent>
              </Card>
            </Fade>
          </Box>
        </Grid>
      </Grid>
      
      {/* Silme Onay Dialog */}
      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, id: null, type: "" })}>
        <DialogTitle>{T.confirm}</DialogTitle>
        <DialogContent>
          <Typography>{T.delete}?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, id: null, type: "" })}>
            {T.cancel}
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              if (deleteDialog.type === "staff") {
                deleteStaff(deleteDialog.id);
              } else if (deleteDialog.type === "salon") {
                deleteSalon(deleteDialog.id);
              } else if (deleteDialog.type === "table") {
                deleteTable(deleteDialog.salonId, deleteDialog.id);
              }
            }}
          >
            {T.delete}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}